import {
  type ProfileImageCropperReducerActionPayloads,
  type ProfileImageCropperReducerActions,
  type ProfileImageCropperReducerActionTypes,
  RESET_CROPPING_STATE,
  START_CROPPING,
  type StartCroppingActionPayload,
  STOP_CROPPING,
  UPDATE_CONTEXT_PARAMETERS,
  UPDATE_CROPPED_PIXELS,
  UPDATE_CROPPED_PREVIEW,
  UPDATE_IS_MUTATION_IN_FLIGHT,
  UPDATE_ORIGINAL_IMAGE_SIZE,
  UPDATE_PROCESSING_STATE,
  UPDATE_UPLOAD_IMAGE,
  type UpdateContextParametersActionPayload,
  type UpdateCroppedPixelsActionPayload,
  type UpdateCroppedPreviewActionPayload,
  type UpdateIsLoadingPayload,
  type UpdateOriginalImageSizeActionPayload,
  type UpdateProcessingStateActionPayload,
  type UpdateUploadActionPayload,
} from './actionTypes.js';
import { type Dispatch } from 'react';

export type ActionCreators = {
  readonly resetCroppingState: () => void;
  readonly startCropping: ProfileAvatarReducerActionCreator<StartCroppingActionPayload>;
  readonly stopCropping: () => void;
  readonly updateContextParameters: ProfileAvatarReducerActionCreator<UpdateContextParametersActionPayload>;
  readonly updateCroppedPixels: ProfileAvatarReducerActionCreator<UpdateCroppedPixelsActionPayload>;
  readonly updateCroppedPreview: ProfileAvatarReducerActionCreator<UpdateCroppedPreviewActionPayload>;
  readonly updateIsMutationInFlight: ProfileAvatarReducerActionCreator<UpdateIsLoadingPayload>;
  readonly updateOriginalImageSize: ProfileAvatarReducerActionCreator<UpdateOriginalImageSizeActionPayload>;
  readonly updateProcessingState: ProfileAvatarReducerActionCreator<UpdateProcessingStateActionPayload>;
  readonly updateUpload: ProfileAvatarReducerActionCreator<UpdateUploadActionPayload>;
};

type ProfileAvatarReducerActionCreator<
  T = ProfileImageCropperReducerActionPayloads,
> = (payload: T) => void;

export const actionCreatorFactory = (
  dispatch: Dispatch<ProfileImageCropperReducerActions>,
) => {
  const actionCreator =
    (type: ProfileImageCropperReducerActionTypes) =>
    (payload: ProfileImageCropperReducerActionPayloads) => {
      const dispatchAction = {
        payload,
        type,
      } as ProfileImageCropperReducerActions;

      dispatch(dispatchAction);
    };

  return {
    resetCroppingState: () => dispatch({ type: RESET_CROPPING_STATE }),
    startCropping: actionCreator(START_CROPPING),
    stopCropping: () => dispatch({ type: STOP_CROPPING }),
    updateContextParameters: actionCreator(UPDATE_CONTEXT_PARAMETERS),
    updateCroppedPixels: actionCreator(UPDATE_CROPPED_PIXELS),
    updateCroppedPreview: actionCreator(UPDATE_CROPPED_PREVIEW),
    updateIsMutationInFlight: actionCreator(UPDATE_IS_MUTATION_IN_FLIGHT),
    updateOriginalImageSize: actionCreator(UPDATE_ORIGINAL_IMAGE_SIZE),
    updateProcessingState: actionCreator(UPDATE_PROCESSING_STATE),
    updateUpload: actionCreator(UPDATE_UPLOAD_IMAGE),
  };
};
